import React from "react"

export const banner = () => ({
  image: {
    alt: "Watch Care",
    fallback: `${sl.config.jewlr_asset_url}images/info/watches/care/watch-care-banner-desktop.jpg`,
    srcSet: [
      {
        media: "(max-width: 767px)",
        sizes: "100vw",
        srcSet: `${sl.config.jewlr_asset_url}images/info/watches/care/watch-care-banner-mobile-2x.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/care/watch-care-banner-mobile-2x.jpg 1534w`,
      },
      {
        media: "(min-width: 1024px)",
        sizes: "100vw",
        srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/care/watch-care-banner-desktop.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/care/watch-care-banner-desktop.jpg 2x`,
      },
    ],
    style: { width: "100vw" },
  },
  style: { pb: { _: "63%", desktop: "23%", tablet: "24%" } },
  textarea: {
    texts: [
      {
        style: {
          fontSize: { _: 25, tablet: 35 },
          fontWeight: 700,
          margin: "auto",
          mr: { _: "55%", tablet: 0 },
          mt: { _: "27%", tablet: 0 },
        },
        text: "Watch Care",
        type: "title",
      },
    ],
  },
})

export const features = () => [
  {
    content: {
      description:
        "To remove dirt or sediment on the watch case or under the bezel, clean the area with fresh water, and dry it with a soft cloth. When not in use, store your watch in a cool, dry area out of direct sunlight and pull out the crown to extend the life of the battery.",
      position: "left",
      title: "Cleaning & Storing",
    },
    descriptionStyle: { px: { _: 0, desktop: "58px", tablet: 3 } },
    image: {
      alt: "Cleaning & Storing",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/care/care-cleaning-and-storing-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/care/care-cleaning-and-storing.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/care/care-cleaning-and-storing-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-cleaning-and-storing.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-cleaning-and-storing-2x.jpg 2x`,
        },
      ],

      style: { mb: { tablet: 3 }, width: { _: "100%", tablet: "85%" } },
    },
  },
  {
    content: {
      description: (
        <>
          Our genuine leather straps feature integrated quick-release spring
          bars. Comfortable and durable, these classic straps come in widths
          that fit our dress and field watch styles.
          <br />
          <br /> To attach the strap, gently press the quick-release spring bar
          lever inwards to compress the spring bars and slide them securely into
          the watch lugs.
        </>
      ),
      descriptionStyle: { px: { _: 0, desktop: 8, tablet: 2 } },
      position: "right",
      title: "Leather Straps",
    },
    image: {
      alt: "Leather Straps",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/care/care-leather-straps-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/care/care-leather-straps.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/care/care-leather-straps-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-leather-straps.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-leather-straps-2x.jpg 2x`,
        },
      ],
      style: { mb: { tablet: 3 }, width: { _: "100%", tablet: "85%" } },
    },
  },
  {
    content: {
      description: (
        <>
          These quality straps are available in solid link stainless steel or
          link-style premium silicone. Modern and durable, they fit our 38mm
          sport watches and come in a choice of colors. <br />
          <br /> To attach the strap, use the forked end of the spring bar tool
          to gently compress the spring bars, helping them slide securely into
          the watch lugs.
        </>
      ),
      descriptionStyle: { px: { _: 0, desktop: 8, tablet: 5 } },
      position: "left",
      title: "Link Straps",
    },
    image: {
      alt: "Link Straps",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/care/care-link-straps-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/care/care-link-straps.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/care/care-link-straps-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-link-straps.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-link-straps-2x.jpg 2x`,
        },
      ],
      style: { mb: { tablet: 3 }, width: { _: "100%", tablet: "85%" } },
    },
  },
  {
    content: {
      description: (
        <>
          Our mesh straps feature finely woven stainless steel for comfort and
          flexibility. Simple and stylish, these highly durable straps fit our
          32mm and 36mm dress watches.
          <br />
          <br />
          To attach the strap, use the forked end of the spring bar tool to
          gently compress the spring bars, helping them slide securely into the
          watch lugs.
        </>
      ),
      descriptionStyle: { px: { _: 0, desktop: "85px", tablet: 5 } },
      position: "right",
      title: "Mesh Straps",
    },
    image: {
      alt: "Mesh Straps",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/care/care-mesh-straps-desktop.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/care/care-mesh-straps-mobile.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/care/care-mesh-straps-mobile.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-mesh-straps-desktop.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-mesh-straps-desktop.jpg 2x`,
        },
      ],

      style: { mb: { tablet: 3 }, width: { _: "100%", tablet: "85%" } },
    },
  },
  {
    content: {
      description: (
        <>
          Our Nato-style straps feature woven premium-grade nylon with stainless
          steel fittings. Durable and washable, these one-piece rugged straps
          fit our 40mm watch styles.
          <br />
          <br />
          To attach the strap, slide the longer end over the watch pins and
          under the back of the watch, secure it in place by threading it
          through the keeper.
        </>
      ),
      descriptionStyle: { px: { _: 0, desktop: 8, tablet: 5 } },
      position: "left",
      title: "Nato Straps",
    },
    image: {
      alt: "Link Straps",
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/care/care-nato-straps-2x.jpg`,
      srcSet: [
        {
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/watches/care/care-nato-straps.jpg 767w,
                   ${sl.config.jewlr_asset_url}images/info/watches/care/care-nato-straps-2x.jpg 1534w`,
        },
        {
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-nato-straps.jpg 1x,
          ${sl.config.jewlr_asset_url}images/info/watches/care/care-nato-straps-2x.jpg 2x`,
        },
      ],

      style: { mb: { tablet: 3 }, width: { _: "100%", tablet: "85%" } },
    },
  },
]

export const watchCollections = () => [
  {
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      style: {
        mb: 1,
      },
    },
    links: {
      base_style: "button",
      bg: "primary",
      color: "white",
      display: "inline-block",
      padding: "10px 50px",
      text: "Shop Men's",
      url: "/all-mens-watches",
    },
  },
  {
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo.png`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo.png`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      style: {
        mb: 1,
      },
    },
    links: {
      base_style: "button",
      bg: "primary",
      color: "white",
      display: "inline-block",
      padding: "10px 50px",
      text: "Shop Women's",
      url: "/all-womens-watches",
    },
  },
]
